export function getOptions(_this,data) {
  return _this.$request({
    method: "post",
    url: "/waybill/work-space",
    data: data
  })
}